import { render, staticRenderFns } from "./CommentsPreview.vue?vue&type=template&id=6754e62c&scoped=true&"
import script from "./CommentsPreview.vue?vue&type=script&lang=ts&"
export * from "./CommentsPreview.vue?vue&type=script&lang=ts&"
import style0 from "./CommentsPreview.vue?vue&type=style&index=0&id=6754e62c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6754e62c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
